/**
 * Steps and registered callbacks for KeenCorp
 * Joyride
 *
 * Author: Daniel Waghorn
 */

export default {
  id: 'keencorp_joyride',
  steps: [
    // {
    //   target: "svg2",
    //   placement: "right",
    //   title: "Welcome to KeenCorp!",
    //   content: "Follow the steps in this tour to take a test drive of a KeenCorp dashboard.",
    //   yOffset: 93,
    // },
    // {
    //   target: "index-number",
    //   placement: "right",
    //   title: "MoodMetrix",
    //   content: "The top-level KeenCorp Index score is the single, numeric people KPI and gives the day-by-day status of the organization",
    //   yOffset: 70,
    // },
    // {
    //   target: ".rv-xy-plot__inner",
    //   placement: "top",
    //   content: "The graph plots the daily KeenCorp Index scores over time, showing trends and the impact of events",
    //   xOffset: 110,
    // },
    // {
    //   target: '#startDate',
    //   placement: "bottom",
    //   content: "The period under review can be changed according to preference. To zoom in or out, allowing periodic analysis.",
    //   onNext() {
    //     if (!document.getElementById('Job Family:Product Development')) {
    //       document.querySelector('div[title="Job Family"]').click();
    //     }
    //   },
    //   xOffset: 30,
    // },
    // {
    //   target: 'div[title="Diversity"]',
    //   placement: "right",
    //   content: "Bespoke clusters reflect the organization’s own priorities and areas of specific interest.",
    //   onPrev() {
    //     if (!document.getElementById('Job Family:Product Development')) {
    //       document.querySelector('div[title="Job Family"]').click();
    //     }
    //   },
    //   onNext() {
    //     const el = document.getElementById('checkbox:Sales And Marketing')
    //     if (el && !el.checked) {
    //       el.disabled = false;
    //       el.click();
    //       el.disabled = true;
    //     }
    //   },
    //   xOffset: 30,
    //   yOffset: -20,
    // },
    // {
    //   target: 'label[title="Sales And Marketing"]',
    //   placement: "right",
    //   content: "Activating one or more cluster(s) enables comparison to 'All'",
    //   xOffset: 7,
    // },
    // {
    //   target: ".rv-xy-plot__inner",
    //   placement: "top",
    //   content: "In this example: The scores for Sales and Marketing visibly lag behind 'All'. There is a downward trend and the gap with 'All' grows during this period",
    //   xOffset: 110,
    //   yOffset: -40,
    //   onNext() {
    //     const els = [
    //       document.getElementById('checkbox:Business Support'),
    //       document.getElementById('checkbox:Delivery'),
    //       document.getElementById('checkbox:Product Development'),
    //       document.getElementById('checkbox:Sales And Marketing'),
    //       document.getElementById('checkbox:Team Leaders'),
    //       document.getElementById('checkbox:Top Management'),
    //     ];
    //     for (let i = 0; i < els.length; i += 1) {
    //       const el = els[i];
    //       if (el && !el.checked) {
    //         setTimeout(() => {
    //           el.disabled = false;
    //           el.click();
    //           el.disabled = true;
    //         }, 500);
    //       }
    //     }
    //   },
    // },
    {
      target: "div#attitude-heatmap",
      placement: "left",
      title: "Attitude Heatmap",
      content: "The summary status of several clusters at a glance<style>.hopscotch-bubble-arrow-border,.hopscotch-bubble-arrow { display: none; }</style>",
      xOffset: 220,
      yOffset: 40,
    },
    {
      target: 'g[id="Job Family:Business Support"] circle#fill',
      placement: "left",
      content: "The size of the circle indicates the relative volume of this cluster",
      zIndex: 9999,
      xOffset: -15,
      yOffset: 50,
    },
    {
      target: 'g[id="Job Family:Delivery"] > g > text',
      placement: "left",
      content: "The KeenCorp Index score of the cluster",
      zIndex: 9999,
      yOffset: -9,
    },
    {
      target: 'g[id="Job Family:Sales And Marketing"] circle#fill',
      placement: "left",
      content: "A bright color ring identifies a significant upward or downward trend",
      zIndex: 9999,
    },
    {
      target: 'g[id="Job Family:Sales And Marketing"] > g > g > path',
      placement: "right",
      content: "The double downward arrow indicates a negative trend compared to 'All'",
      zIndex: 9999,
      yOffset: -20,
    },
    {
      target: 'g[id="Job Family:Sales And Marketing"] circle#fill',
      placement: "left",
      content: "<b>In this example:</b><br>The Sales and Marketing is highlighted and shows a significant downward trend. <br><br><b>Conclusion:</b><br>This team may require attention",
      zIndex: 9999,
    },
    {
      target: 'g[id="Job Family:Team Leaders"] circle#fill',
      placement: "left",
      content: "By comparison the cluster 'Team Leaders' scores relatively high (112) and there is no significant up or downward trend. <br><br><b>Conclusion:</b><br>No action required.<br><br>Thank you for taking this test drive!",
      zIndex: 9999,
    },
  ],
  showPrevButton: true,
  scrollTopMargin: 100,
};



// WEBPACK FOOTER //
// ./src/demo_tour.js